import { useEffect } from "react";
import { observeSpaNavigation } from "../../util/spa-title-watcher";

const pathTitleMatchers: [RegExp, string][] = [
  [/^\/?$/, "Início"],
  [/^\/app\/catalog\/?$/, "Início"],
  [/\/carta-de-servicos/, "Carta de Serviços"],
  [/\/noticias/, "Notícias"],
  [/\/secretarias-e-orgaos/, "Secretarias e Órgãos"],
  [/\/ouvidoria/, "Ouvidoria"],
  [/\/agendamento-servicos/, "Agendamento de Serviço"],
  [/\/meus-dados/, "Meus dados"],
  [/\/cnh-definitiva/, "CNH Definitiva"],
  [/\/cnh-segunda-via/, "Segunda Via da CNH"],
  [/^\/app\/painel-cidadao(\/.*)?$/, "Painel do Cidadão"],
];

const getPageTitleFromPath = (path: string): string => {
  for (const [regex, title] of pathTitleMatchers) {
    if (regex.test(path)) {
      return title;
    }
  }
  return "Portal do Cidadão";
};

export const TitleUpdater = () => {
  useEffect(() => {
    const stopObserving = observeSpaNavigation((path) => {
      var title = `${getPageTitleFromPath(
        path
      )} - Portal do Governo de Pernambuco`;
      if (getPageTitleFromPath(path) === "Início") {
        title = "Portal do Governo de Pernambuco";
      }
      document.title = title;
    });

    return () => stopObserving();
  }, []);

  return null;
};
